import React from 'react';
import T from 'i18n-react';

const EmptyCart = (props) =>{
    return(
        <div className="empty-cart">
            <img src="https://res.cloudinary.com/sivadass/image/upload/v1495427934/icons/empty-cart.png" alt="empty-cart"/>
            <h2>{T.translate("labels.cartEmpty")}</h2>
        </div>
    )
};

export default EmptyCart;


// WEBPACK FOOTER //
// ./src/empty-states/EmptyCart.js